// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ee8c9091","732":"946fdafe","977":"1097e350"}[chunkId] + ".chunk.js";
};